import React from "react";

const defaultEmployeeData1 = [
  {
    category: "Number of Permanent Employees",
    total: "",
    female: "",
    male: "",
    nonBinary: "",
  },
  {
    category: "Number of Non- Permanent Employees",
    total: "",
    female: "",
    male: "",
    nonBinary: "",
  },
];

const TotalEmployeesTable2 = ({ employeeTable2, setEmployeeTable2 }) => {
  const safeData = Array.isArray(employeeTable2)
    ? employeeTable2
    : defaultEmployeeData1;

  const handleInputChange = (rowIndex, field, value) => {
    const updatedData = [...safeData];
    updatedData[rowIndex][field] = value;
    setEmployeeTable2(updatedData);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        width: "100%",
        overflow: "hidden",
        borderRadius: "8px",
        border: "1px solid #000",
      }}
    >
      <table style={tableStyle}>
        <thead>
          <tr style={headerRowStyle}>
            <th style={{ ...tableHeaderStyle, borderTopLeftRadius: "10px" }}>
              Total Number of Employees
            </th>
            <th style={tableHeaderStyle}>Total</th>
            <th style={tableHeaderStyle}>Female</th>
            <th style={tableHeaderStyle}>Male</th>
            <th style={{ ...tableHeaderStyle, borderTopRightRadius: "10px" }}>
              Non-Binary
            </th>
          </tr>
        </thead>
        <tbody>
          {safeData.map((row, index) => (
            <tr key={index}>
              <td style={boldCellStyle}>{row.category}</td>
              <td style={tableCellStyle}>
                <input
                  type="number"
                  value={row.total}
                  onChange={(e) =>
                    handleInputChange(index, "total", e.target.value)
                  }
                  style={inputFieldStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="number"
                  value={row.female}
                  onChange={(e) =>
                    handleInputChange(index, "female", e.target.value)
                  }
                  style={inputFieldStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="number"
                  value={row.male}
                  onChange={(e) =>
                    handleInputChange(index, "male", e.target.value)
                  }
                  style={inputFieldStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="number"
                  value={row.nonBinary}
                  onChange={(e) =>
                    handleInputChange(index, "nonBinary", e.target.value)
                  }
                  style={inputFieldStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Table and cell styles
const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
};

const headerRowStyle = {
  backgroundColor: "#D3C9CE",
  color: "#000",
};

const tableHeaderStyle = {
  padding: "12px",
  border: "1px solid #000",
  textAlign: "center",
  fontWeight: "bold",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const boldCellStyle = {
  ...tableCellStyle,
  backgroundColor: "#D3C9CE",
  fontWeight: "bold",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "6px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default TotalEmployeesTable2;
